import React from "react";
import { Divider } from "@/components/Divider";

export const SectionHeader = ({ eyebrow, title, subtitle, align = "left", testid }) => {
  return (
    <div className={`mb-10 ${align === "center" ? "text-center mx-auto max-w-2xl" : ""}`} data-testid={testid}>
      {eyebrow && (
        <p className="text-xs uppercase tracking-[0.25em] text-[#00A651] font-bold mb-3">
          {eyebrow}
        </p>
      )}
      <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-black tracking-tight">
        {title}
      </h2>
      {subtitle && (
        <p className="font-sub italic text-lg sm:text-xl text-gray-600 mt-3">
          {subtitle}
        </p>
      )}
      <div className={`mt-5 ${align === "center" ? "flex justify-center" : ""}`}>
        <Divider />
      </div>
    </div>
  );
};

export default SectionHeader;
